import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.order-planning-configuration')
  .factory('OrdersPlanningConfigurationAPI', OrdersPlanningConfigurationAPI);

function OrdersPlanningConfigurationAPI(): BringozApi {
  return {
    base: `/customOrderPlanningConfiguration`,
    infiniteScroll: {
      address: `/customOrderPlanningConfiguration`,
      cmd: 'GET'
    },
    actions : {
      create: {
        address : '',
        cmd : 'PUT',
        updateable: false
      },
      update: {
        address : '{id}',
        cmd : 'POST',
        updateable: false
      },
      delete: {
        address : '{id}',
        cmd : 'DELETE',
        updateable: false
      },
    }
  }
}
